<template>
  <b-modal
    id="people-favorited"
    :modal-class="'default-modal'"
    :hide-footer="true"
    ref="peopleFavorited"
    @shown="shown"
    @hidden="hidden"
  >
    <template v-slot:modal-title>
      Quem curtiu
    </template>

    <template v-slot:default>
      <div
        v-if="list.length > 0"
      >
        <div
          v-for="user in list"
          :key="user.entity.id"
        >
          <UserListItem
            :user="user.entity"
          />
        </div>
        <div class="text-center mt-3">
          <Button
            class="btn-outline-color2 btn-sm"
            :loading="loader"
            v-if="isLoadMoreVisible"
            @click="loadMore"
          >
            Carregar mais
          </Button>
        </div>
      </div>
      <Loader
        color="color2"
        size="big"
        v-else-if="loader"
      />
      <p class="text-center font-size-small" v-else>Sem curtidas no momento</p>
    </template>
  </b-modal>
</template>

<script>

import FavoritesService from '@/modules/favorites/services/favorites-service'

import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button.vue'
import Loader from '@/components/common/Loader/Loader.vue'
import UserListItem from '@/components/user/UserListItem'

export default {
  name: 'PeopleFavoritedModal',
  props: ['target', 'type'],
  data () {
    return {
      list: [],
      loader: false,
      isLoadMoreVisible: true,
      page: 1
    }
  },
  components: {
    Button,
    Loader,
    UserListItem
  },
  computed: {
    ...mapState('users', {
      authUser: state => state.user
    })
  },
  methods: {
    async getList () {
      this.loader = true
      try {
        const list = await FavoritesService.getFavorites({ id: this.target, modelType: this.type, page: this.page })
        this.list = [...this.list, ...list]
        this.isLoadMoreVisible = list.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    loadMore () {
      this.page++
      this.getList()
    },
    shown () {
      this.getList()
    },
    hidden () {
      this.list = []
      this.page = 1
    },
    followToggled (e) {
      this.$emit('follow-toggled', e)
    }
  }
}
</script>
